._3hpz080 {
  display: flex;
  position: relative;
  padding: 16px;
  border-radius: var(--_6225eru);
  box-shadow: var(--_6225erp);
  font-size: var(--_6225er23);
  font-weight: var(--_6225er24);
  align-items: flex-start;
  margin-bottom: 16px;
  gap: 16px;
  grid-column: 1 / -1;
}
._3hpz080:not(:first-child) {
  margin-top: 16px;
}
._3hpz080:last-child {
  margin-bottom: 0;
}
._3hpz081 {
  display: flex;
  align-items: center;
  justify-content: center;
  aspect-ratio: 1 / 1;
  font-size: 20px;
  flex: 0 0 38px;
  border-radius: var(--_6225eru);
  color: var(--_6225er6);
  background: var(--_6225er4);
}
._3hpz082 {
  display: flex;
  flex-direction: column;
  text-align: left;
  flex: 1;
  gap: 4px;
}
._3hpz083 {
  padding-right: 48px;
}
._3hpz084 {
  position: absolute;
  top: 16px;
  right: 16px;
  background: none;
  border: none;
  margin-left: auto;
  cursor: pointer;
  transition: opacity 0.2s;
}
._3hpz084:hover {
  opacity: 0.8;
}
._3hpz085 {
  font-size: var(--_6225er1z);
}
._3hpz080 ._3hpz085:not(:first-child):before {
  content: "";
  text-decoration: none;
  margin: 0 4px;
}
._3hpz086 {
  background: var(--_6225er4);
}
._3hpz087 {
  background: var(--_6225er6);
}
._3hpz088 {
  background: var(--_6225erl);
}
._3hpz089 {
  background: var(--_6225erh);
}
._3hpz08a {
  background: var(--_6225erf);
}
._3hpz08b {
  background: var(--_6225er4);
}
._3hpz08c {
  color: var(--_6225er6);
}
._3hpz08d {
  color: var(--_6225er6);
}
._3hpz08e {
  color: var(--_6225erl);
}
._3hpz08f {
  color: var(--_6225erh);
}
._3hpz08g {
  color: var(--_6225erf);
}
._3hpz08h {
  color: var(--_6225er4);
}
._3hpz08i {
  background: var(--_6225er4);
  color: var(--_6225er6);
}
._3hpz08j {
  background: var(--_6225er6);
}
._3hpz08k {
  background: var(--_6225erm);
}
._3hpz08l {
  background: var(--_6225erj);
}
._3hpz08m {
  background: var(--_6225erg);
}
._3hpz08n {
  background: var(--_6225era);
}